"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const react_1 = __importDefault(require("react"));
const Input_1 = require("@mui/base/Input");
require("./Input.scss");
//
// export const Input = React.forwardRef(function CustomInput(
//   props: React.InputHTMLAttributes<HTMLInputElement> & InputProps,
//   ref: React.ForwardedRef<HTMLInputElement>,
// ) {
//   const {getRootProps, getInputProps} = useInput(props);
//
//   const inputProps = getInputProps();
//
//   // Make sure that both the forwarded ref and the ref returned from the getInputProps are applied on the input element
//   inputProps.ref = useForkRef(inputProps.ref, ref);
//
//   return (
//     <div {...getRootProps()}>
//       <input
//         {...props}
//         {...inputProps}
//         className={cl(style.Input, props.className)}
//       />
//     </div>
//   );
// });
function Input(props) {
    return react_1.default.createElement(Input_1.Input, Object.assign({}, props));
}
exports.Input = Input;
//# sourceMappingURL=Input.js.map